<template>
  <div class="mod-user">
    <div class="searchBox" :style="{ opacity: config.isConfigMode ? 0.5 : 1, pointerEvents: config.isConfigMode ? 'none' : 'auto' }">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="申请类型">
          <el-select class="item-choose"
                     v-model="dataForm.requestType"
                     size="small"
                     filterable clearable placeholder="请选择">
            <el-option
              v-for="item in dictTypeMap.driver_repair"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人">
          <el-input v-model="dataForm.driverName" placeholder="支持模糊查询" clearable></el-input>
        </el-form-item>
        <el-form-item label="车牌号">
          <el-input v-model="dataForm.vehiclePlate" placeholder="支持模糊查询" clearable></el-input>
        </el-form-item>
        <el-form-item label="维修项目">
          <el-input v-model="dataForm.repairName" placeholder="支持模糊查询" clearable></el-input>
        </el-form-item>
        <el-form-item label="维保状态">
          <el-select class="item-choose"
                     v-model="dataForm.repairStatus"
                     size="small"
                     filterable clearable placeholder="请选择">
            <el-option label="待审核" value="0"></el-option>
            <el-option label="已审核" value="1"></el-option>
            <el-option label="已完成" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款状态" prop="writeStatus">
          <el-select class="item-choose" v-model="dataForm.writeStatus" style="width: 100%;" filterable clearable
                     placeholder="请选择">
            <el-option label="已付款" value="1"></el-option>
            <el-option label="未付款" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维修供应商">
          <el-select class="item-choose"
                     v-model="dataForm.repairItem"
                     size="small"
                     filterable clearable placeholder="请选择">
            <el-option
              v-for="item in dictTypeMap.repair_factory"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期">
          <el-date-picker
            v-model="dataForm.requestDate"
            type="daterange" align="right" unlink-panels range-separator="-"
            size="small" value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="$store.state.common.pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="维修完成时间">
          <el-date-picker
            v-model="dataForm.successTime"
            type="daterange" align="right" unlink-panels range-separator="-"
            size="small" value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="$store.state.common.pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" type="primary">查询</el-button>

        </el-form-item>
        <el-form-item>
          <el-button @click="addOrUpdateHandle('add')" type="primary">新增</el-button>
          <el-button @click="downLoad()" type="success">导出</el-button>
        </el-form-item>
        <el-form-item style="text-align: right; display: flex; justify-content: flex-end; align-items: center;">
          <div class="operationList">
            <el-button size="small" type="success" v-if="newAuth('cost:receivable:update')" @click="openWriteOffPopup(1)"
                       :disabled="!selectFeeData.length">已付款核销
            </el-button>
            <el-button size="small" type="success" v-if="newAuth('cost:receivable:update')" @click="batchAudit(2)"
                       :disabled="!selectFeeData.length">反核销
            </el-button>
            <el-button type="info" size="small" v-if="newAuth('driver:repair:audit')" :disabled="!(addOrUpdateHandleAudit && addOrUpdateHandleAudit.repairStatus == 0)" @click="addOrUpdateHandle('audit', addOrUpdateHandleAudit.id)">审核</el-button>
            <el-button type="info" size="small" v-if="newAuth('driver:repair:audit')" :disabled="!(addOrUpdateHandleAudit && addOrUpdateHandleAudit.repairStatus == 1)" @click="addOrUpdateHandle('back', addOrUpdateHandleAudit.id)">反审核</el-button>
            <el-button size="small" @click="templateConfigurationMode(0)" type="warning">模板配置模式</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox" :style="{ position: 'relative' }">
      <!-- 配置模式 -->
      <el-row v-if="config.isConfigMode" style="justify-self: center;padding: 10px 10px">
        <el-button size="mini" @click="config.isConfigMode = false" type="danger">取消配置模式</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(1)" type="success">保存模板</el-button>
        <el-button v-no-more-click size="mini" @click="templateConfigurationMode(2)" type="warning">修改模板</el-button>
        <el-button v-no-more-click size="mini" @click="$refs.configTableRef.init(config.configTableId)" type="warning">所有模板</el-button>
        <el-popover placement="right" width="520" trigger="click">
          <div style="justify-self: center;">
            <el-button v-no-more-click @click="checkAllNodes(true)" size="mini">全选</el-button>
            <el-button v-no-more-click @click="checkAllNodes(false)" size="mini">全不选</el-button>
            <el-tooltip class="item" effect="dark" content="可拖拽必须先取消固定才允许拖拽排列,如果有固定固定按钮会显示为绿色" placement="top-start">
              <i class="el-icon-view el-icon--right" />
            </el-tooltip>
          </div>
          <br/>
          <el-tree :data="config.configDefaultColumn"
                   style="max-height: 200px;overflow-y: auto;"
                   default-expand-all
                   show-checkbox
                   draggable
                   node-key="prop"
                   ref="configTableListTree"
                   @check-change="handleCheckChange"
                   @node-drop="handleDrop"
                   :allow-drag="allowDrag"
                   :allow-drop="allowDrop">
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <el-row :gutter="20">
                       <el-col :span="16">
                         <div class="grid-content bg-purple">
                           <el-input size="mini" placeholder="列头名" v-model="data.label"></el-input>
                         </div>
                       </el-col>
                       <el-col :span="8">
                         <div class="grid-content bg-purple">
                           <el-link :type="data.fixed && data.fixed === 'left' ? 'success' : 'info'" @click="data.fixed = 'left'" :underline="false" >固定左侧</el-link>
                           <el-link :type="data.fixed && data.fixed === 'right' ? 'success' : 'info'" @click="data.fixed = 'right'" :underline="false" >固定右侧</el-link>
                           <el-link :disabled="!data.fixed" :underline="false" @click="data.fixed = undefined" >取消固定</el-link>
                         </div>
                       </el-col>
                    </el-row>
                  </span>
          </el-tree>
          <el-button style="margin-left: 10px;" size="mini" slot="reference" icon="el-icon-s-tools" circle />
        </el-popover>
        <br/>
        <br/>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-input v-model="config.configModeForm.name" size="mini" placeholder="模板名称" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple-light">
              <el-input v-model="config.configModeForm.remark" size="mini" placeholder="备注" clearable />
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-switch
                  v-model="config.configModeForm.defaultOrNot"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  :active-value="'1'"
                  :inactive-value="'0'">
              </el-switch>
            </div>
          </el-col>
        </el-row>
      </el-row>

      <el-table height="72vh"
                ref="tableRef"
                @row-click="rowClick"
                :summary-method="getSummaries"
                show-summary
                :row-style="selectedHighlight"
                :data="dataList"
                border size="small"
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
        <el-table-column type="selection" width="35" fixed="left" align="center"></el-table-column>
        <el-table-column type="index" label="序号" width="40" align="center"></el-table-column>
        <el-table-column
            v-for="(item, index) in config.configDefaultColumn"
            :key="index"
            align="left"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :show-overflow-tooltip="true"
            v-if="item.check"
            :class="item.styleClass"
            :class-name="item.styleClass">
          <template slot-scope="scope">
            <!-- 维修前照片 -->
            <template v-if="item.prop == '维修前照片'">
              <span @click="viewPhoto(scope.row, repairBeforeTypeList)" style="color: blue;cursor:pointer">查看</span>
            </template>
            <!-- 现金票据 -->
            <template v-else-if="item.prop == '现金票据'">
              <span @click="viewPhoto(scope.row, cashPaymentTypeList)" style="color: blue;cursor:pointer">查看</span>
            </template>
            <!-- 月结票据 -->
            <template v-else-if="item.prop == '月结票据'">
              <span @click="viewPhoto(scope.row, repairCostTypeList)" style="color: blue;cursor:pointer">查看</span>
            </template>
            <!-- 维修后照片 -->
            <template v-else-if="item.prop == '维修后照片'">
              <span @click="viewPhoto(scope.row, repairAfterTypeList)" style="color: blue;cursor:pointer">查看</span>
            </template>
            <!-- 维保状态 -->
            <template v-else-if="item.prop == 'repairStatus'">
              <el-tag v-if="scope.row.repairStatus === 0" size="small" type="danger">待审核</el-tag>
              <el-tag v-if="scope.row.repairStatus === 1" size="small" type="success">已审核</el-tag>
              <el-tag v-if="scope.row.repairStatus === 2" size="small" type="info">已完成</el-tag>
            </template>
            <!-- 付款状态 -->
            <template v-else-if="item.prop == 'writeStatus'">
              <el-tag v-if="scope.row.writeStatus == 1" size="small" type="success">已付款</el-tag>
              <el-tag v-if="scope.row.writeStatus == 2" size="small" type="danger">未付款</el-tag>
            </template>
            <template v-else>
              {{ getFormatter(item.formatter)(scope.row, item, _.get(scope.row, item.prop)) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column fixed="right" header-align="center" width="40" label="操作">
          <template slot-scope="scope">
            <el-popover placement="bottom" popper-class="popoerOpt" class="popoerBox" trigger="click">
              <el-button v-if="newAuth('driver:repair:find')" type="text" size="small" @click="addOrUpdateHandle('view', scope.row.id)">详情</el-button>
              <el-button v-if="newAuth('driver:repair:update')" type="text" @click="addOrUpdateHandle('update',scope.row.id)" size="small">修改</el-button>
              <el-button v-if="newAuth('driver:repair:delete')" type="text" @click="deleteInfo(scope.row.id)" size="small">删除</el-button>
              <el-button slot="reference" class="referenceBtn">
                <icon-svg name="caozuo" class="site-sidebar__menu-icon"></icon-svg>
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
        :current-page="pageIndex"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :total="totalPage"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>

    <!-- 弹窗, 新增 / 修改 -->
    <repair-request ref="repairRequest" @refreshDataList="getDataList"></repair-request>
    <!-- 查看图片 -->
    <view-image ref="viewPhoto"></view-image>

    <!--审核弹窗-->
    <write-off-popup ref="writeOff" @refreshDataList="getDataList"></write-off-popup>

    <!-- 模板配置弹窗 -->
    <configTable ref="configTableRef" />
  </div>
</template>

<script>
import configTable from '@/components/table'
import RepairRequest from './details/repair-request'
import viewImage from '@/views/commonPop/viewImage'
import writeOffPopup from './details/write-off-popup'
import * as myJsonClon from "@/utils/myJsonClone";

export default {
  data () {
    return {
      // -----------------动态表格模式start-----------------
      config: {
        configId: null,
        configTableId: 50,
        configDefaultColumn: [
          {label: '申请类型',prop: 'requestType',width: '60',check: true,fixed: undefined},
          {label: '申请日期',prop: 'requestDate',width: '130',check: true,fixed: undefined},
          {label: '申请人',prop: 'driverName',width: '70',check: true,fixed: undefined},
          {label: '车牌号',prop: 'vehiclePlate',width: '80',check: true,fixed: undefined},
          {label: '行驶里程',prop: 'travelMileage',width: '70',check: true,fixed: undefined},
          {label: '申请说明',prop: 'repairDesc',width: '100',check: true,fixed: undefined},
          {label: '维修前照片',prop: '维修前照片',width: '70',check: true,fixed: undefined},
          {label: '督导意见',prop: 'analysis',width: '70',check: true,fixed: undefined},
          {label: '维修供应商',prop: 'repairItem',width: '90',check: true,fixed: undefined},
          {label: '现金支付',prop: 'cashPayment',width: '70',check: true,fixed: undefined},
          {label: '现金票据',prop: '现金票据',width: '70',check: true,fixed: undefined},
          {label: '月结支付',prop: 'repairCost',width: '70',check: true,fixed: undefined},
          {label: '月结票据',prop: '月结票据',width: '70',check: true,fixed: undefined},
          {label: '维保说明',prop: 'repairRemark',width: '90',check: true,fixed: undefined},
          {label: '维修后照片',prop: '维修后照片',width: '70',check: true,fixed: undefined},
          {label: '维修完成时间',prop: 'successTime',width: '130',check: true,fixed: undefined},
          {label: '费用小计',prop: 'payableAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined},
          {label: '已付小计',prop: 'paidAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined},
          {label: '未付小计',prop: 'notPayableAmount',width: '70',formatter: 'getNumValue',check: true,fixed: undefined},
          {label: '创建人',prop: 'createName',width: '60',check: true,fixed: undefined},
          {label: '核销人',prop: 'writeName',width: '60',check: true,fixed: undefined},
          {label: '核销时间',prop: 'writeDate',width: '60',check: true,fixed: undefined},
          {label: '维保状态',prop: 'repairStatus',width: '60',check: true,fixed: 'right'},
          {label: '付款状态',prop: 'writeStatus',width: '60',check: true,fixed: 'right'},
        ],
        configDefaultPropColumn: [],
        isConfigMode: false,
        configModeForm: {
          name: '',
          remark: '',
          defaultOrNot: '0'
        },
        configDefaultPropColumnMap: new Map(),
      },
      // -----------------动态表格模式end-----------------

      dataForm: {
        requestType: null,
        vehiclePlate: null,
        repairName: null,
        repairStatus: null,
        writeStatus: null,
        repairItem: null,
        successTime: null,
        requestDate: null,
        driverName: null
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      getIndex: -1,
      totalPage: 0,
      repairBeforeTypeList: [5007],
      repairAfterTypeList: [5008],
      cashPaymentTypeList: [7009],
      repairCostTypeList: [7010],
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      selectFeeData: [],
      addOrUpdateHandleAudit: null,
    }
  },
  components: {
    configTable,
    RepairRequest,
    viewImage,
    writeOffPopup
  },
  created () {
    this.initConfigTable()

    this.setDefaultDate()
  },
  activated () {
    this.getDataList()
  },
  computed: {
    dictTypeMap: {
      get () {
        return this.$store.state.common.dictTypeMap
      }
    }
  },
  methods: {
    // -----------------动态表格模式start-----------------
    initConfigTable() {
      this.$http({
        url: this.$http.adornUrl('/tabulation/default/' + this.config.configTableId),
        method: 'get',
        params: this.$http.adornParams()
      }).then(async ({ data }) => {
        if (data) {
          this.config.configModeForm.name = data.name
          this.config.configModeForm.remark = data.remark
          this.config.configModeForm.defaultOrNot = data.defaultOrNot
          this.config.configId = data.id
          if (data.tmsTabulationConfigValueList && data.tmsTabulationConfigValueList.length > 0) {
            this.assignPropertiesLarge(this.config.configDefaultColumn, data.tmsTabulationConfigValueList,'prop',['label','fixed','width'])
            this.config.configDefaultColumn = this.reorderArray(this.config.configDefaultColumn, data.tmsTabulationConfigValueList, 'prop');
          }
        }
        this.config.configDefaultColumn.forEach(x => {
          this.config.configDefaultPropColumn.push({prop: x.prop})
          this.config.configDefaultPropColumnMap.set(x.prop,x)
        })
      })

    },
    assignPropertiesLarge (arr1, arr2, compareProp, assignProps) {
      const map = new Map();
      arr2.forEach(item => {
        map.set(item[compareProp], item);
      });
      arr1.forEach(item => {
        const match = map.get(item[compareProp]);
        if (match) {
          assignProps.forEach(prop => {
            item[prop] = match[prop];
          });
          item.check = true
        } else {
          item.check = false
        }
      });
      return arr1;
    },
    reorderArray(arr1, arr2, key) {
      if (arr2.length === 0) {
        return arr1;
      }

      // 存储第二个数组中元素的特定属性值
      const targetValues = arr2.map(item => item[key]);
      // 存储匹配的元素
      const matched = [];
      // 存储未匹配的元素
      const unmatched = [];

      // 遍历第一个数组，将匹配的元素和未匹配的元素分别存储
      for (const item of arr1) {
        if (targetValues.includes(item[key])) {
          matched.push(item);
        } else {
          unmatched.push(item);
        }
      }

      // 对匹配的元素进行排序，使其顺序与第二个数组一致
      const sortedMatched = targetValues.map(value => {
        return matched.find(item => item[key] == value);
      }).filter(item => item!== undefined);
      // 合并匹配的元素和未匹配的元素
      return [...sortedMatched, ...unmatched];
    },
    templateConfigurationMode(type) {
      // 开启配置模式
      if (type === 0) {
        this.config.isConfigMode = true
        this.$nextTick(() => {
          const tree = this.$refs.configTableListTree;
          this.config.configDefaultColumn.forEach((node) => {
            if (node.check) {
              tree.setChecked(node.prop, true);
            }
          });
        })
      }
      // 保存/修改配置模式
      else if (type === 1 || type === 2) {
        // 检测
        if (!this.config.configModeForm.name) {
          this.$message.error('请输入配置模板名称!');
          return
        }
        if (type === 2) {

          if (!this.config.configId) {
            this.$message.error('未检测出有配置相关模板并启用,请新增!');
            return
          }
        }
        this.$nextTick(() => {
          let submitTable = myJsonClon.getClone(this.config.configModeForm)
          submitTable.tableId = this.config.configTableId
          submitTable.id = type === 2 ? this.config.configId : undefined
          const tableRef = this.$refs.tableRef;
          let tmsTabulationConfigValueList = []
          tableRef.columns.forEach((x,index) => {
            tmsTabulationConfigValueList.push({label: x.label,prop: x.property,fixed: x.fixed,width: x.width,sort: index})
          })
          submitTable.tmsTabulationConfigValueList = tmsTabulationConfigValueList;
          this.$http({
            url: this.$http.adornUrl(type === 1 ? '/tabulation/add' : '/tabulation/update'),
            method: type === 1 ? 'post' : 'put',
            data: submitTable
          }).then(async ({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
            })
            window.location.reload()
          })

        })
      }
    },
    getFormatter(formatterName) {
      if (formatterName) {
        // 首先尝试从组件的 methods 中获取方法
        let method = this[formatterName];
        if (typeof method === 'function') {
          return method;
        }
        // 若组件的 methods 中没有，再尝试从 Vue.prototype 中获取方法
        method = Vue.prototype[formatterName];
        if (typeof method === 'function') {
          return method;
        }
      }
      // 若都没找到，返回一个直接返回原始值的函数
      return (row, column, cellValue) => cellValue;
    },
    checkAllNodes (isChecked) {
      this.$nextTick(() => {
        if (isChecked) {
          this.$refs.configTableListTree.setCheckedNodes(this.config.configDefaultPropColumn)
        } else {
          this.$refs.configTableListTree.setCheckedKeys([])
          this.$forceUpdate()
        }
      })
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const tree = this.$refs.configTableListTree;
      tree.setChecked(draggingNode.data.prop, draggingNode.data.check);
    },
    handleCheckChange(data, checked, indeterminate) {
      const targetElement = this.config.configDefaultColumn.find(item => item.prop === data.prop);
      targetElement.check = checked
    },
    allowDrag(draggingNode) {
      return draggingNode.data.fixed ? false : true
    },
    allowDrop(draggingNode, dropNode, type) {
      return type === 'inner' ? false : true
    },
    getCellClassName({ row, column, rowIndex, columnIndex }) {
      let newVar = this.config.configDefaultPropColumnMap.get(column.property);
      if (newVar && newVar.styleClass) {
        return newVar.styleClass;
      }
      return '';
    },
    // -----------------动态表格模式end-----------------

    setDefaultDate () {
      let end = new Date()
      let start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      this.dataForm.requestDate = [this.dateFormatter(start, 'yyyy-MM-dd'), this.dateFormatter(end, 'yyyy-MM-dd')]
    },
    getNumValue (row, cell, value) {
      return this.getValue(value)
    },
    getValue (value) {
      if (value === 0) {
        return ''
      } else {
        return value
      }
    },
    openWriteOffPopup (writeStatus) {
      this.writeOffVisible = true
      let ids = []
      this.selectFeeData.forEach(item => {
        // 已付款和申请中的不可核销
        if (item.writeStatus !== writeStatus) {
          ids.push(item.id)
        }
      })
      if (ids.length === 0) {
        this.$message.error('没有符合核销的数据，请检查是否勾选正确')
        return
      }
      this.$refs.writeOff.init(this.dataForm.requestType, writeStatus, ids)
    },
    batchAudit (writeStatus) {
      let ids = []
      this.selectFeeData.forEach(item => {
        if (item.writeStatus !== writeStatus) {
          ids.push(item.id)
        }
      })
      if (ids.length === 0) {
        this.$message.error('没有符合核销的数据，请检查是否勾选正确')
        return
      }
      let title = '费用核销'
      if (writeStatus === 2) {
        title = '反核销'
      }
      this.$confirm('是否继续执行【' + title + '】操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/driverRepair/batchWrite`),
          method: 'POST',
          data: this.$http.adornData({
            ids: ids,
            writeStatus: writeStatus
          })
        }).then(({ data }) => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error('操作失败')
          }
        })
      }).catch(() => {
      })
    },
    // 查看照片
    viewPhoto (row, typeList) {
      this.$refs.viewPhoto.init(row.id, typeList)
    },
    /**
     * 点击表格变色start
     */
    selectedHighlight ({ row, rowIndex }) {
      if ((this.getIndex) === rowIndex) {
        return {
          'background-color': 'rgb(250, 195, 100)'
        }
      }
    },
    // 如果为已取消时，该行置灰
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex
      if (row.status === 12) {
        return 'cancel-row'
      }
      return ''
    },
    rowClick (row) {
      this.getIndex = row.index
    },
    /**
     *自定义合计
     */
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => {
          if (column.property && (column.property.indexOf('cashPayment') > -1)) {
            return this.getValue(item[column.property])
          }
          // 维保金额
          if (column.property && (column.property.indexOf('repairCost') > -1)) {
            return this.getValue(item[column.property])
          }
          if (column.property && (column.property.indexOf('payableAmount') > -1)) {
            return this.getValue(item[column.property])
          }
          if (column.property && (column.property.indexOf('paidAmount') > -1)) {
            return this.getValue(item[column.property])
          }
          if (column.property && (column.property.indexOf('notPayableAmount') > -1)) {
            return this.getValue(item[column.property])
          }
        })
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return this.numFilter(this.getValue(Number(prev) + curr))
            } else {
              return this.numFilter(this.getValue(prev))
            }
          }, 0)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    getAllSummaries (row) {
      // 合计参数，按顺序返回
      let param = []
      param.push('合计')
      this.config.configDefaultPropColumn.forEach(x => {
        let value = row[`${x.prop}`]
        param.push(value == undefined ? '' : value)
      })
      // 创建列表行
      let tr = document.createElement('tr')
      // 删除上一条合计
      if (document.querySelector('.el-table__footer-wrapper table tbody').childElementCount === 2) {
        document.querySelector('.el-table__footer-wrapper table tbody').lastChild.remove()
      }
      // td赋值
      param.forEach((item, index) => {
        let td = document.createElement('td')
        td.innerHTML = item
        td.align = 'center'
        tr.appendChild(td)
      })
      // 添加合计
      document.querySelector('.el-table__footer-wrapper table tbody').appendChild(tr)
    },
    downLoad () {
      let successTime = this.dataForm.successTime
      let timeParam = {}
      if (successTime && successTime.length === 2) {
        timeParam.refuelBeginDate = successTime[0]
        timeParam.refuelEndDate = successTime[1]
      }
      this.$http({
        url: this.$http.adornUrl(`/export/driverRepairExport`),
        method: 'get',
        responseType: 'blob',
        params: this.$http.adornParams({
          'requestType': this.dataForm.requestType,
          'driverName': this.dataForm.driverName, // 申请人
          'vehiclePlate': this.dataForm.vehiclePlate,
          'repairName': this.dataForm.repairName,
          'repairStatus': this.dataForm.repairStatus,
          'writeStatus': this.dataForm.writeStatus,
          'repairItem': this.dataForm.repairItem,
          'refuelBeginDate': timeParam.refuelBeginDate,
          'refuelEndDate': timeParam.refuelEndDate
        })
      }).then(({ data }) => {
        const blob = data
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = (e) => {
          const a = document.createElement('a')
          a.download = '维修登记表.xls'
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      })
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      let successTime = this.dataForm.successTime
      let timeParam = {}
      if (successTime && successTime.length === 2) {
        timeParam.refuelBeginDate = successTime[0]
        timeParam.refuelEndDate = successTime[1]
      }
      // 申请日期
      let requestDate = this.dataForm.requestDate
      let timeParam1 = {}
      if (requestDate && requestDate.length === 2) {
        timeParam1.requestBeginDate = requestDate[0]
        timeParam1.requestEndDate = requestDate[1]
      }
      this.$http({
        url: this.$http.adornUrl('/driverRepair/findList'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'requestType': this.dataForm.requestType,
          'driverName': this.dataForm.driverName, // 申请人
          'vehiclePlate': this.dataForm.vehiclePlate,
          'repairName': this.dataForm.repairName,
          'repairStatus': this.dataForm.repairStatus,
          'writeStatus': this.dataForm.writeStatus,
          'repairItem': this.dataForm.repairItem,
          'refuelBeginDate': timeParam.refuelBeginDate,
          'refuelEndDate': timeParam.refuelEndDate,
          'requestBeginDate': timeParam1.requestBeginDate,
          'requestEndDate': timeParam1.requestEndDate
        })
      }).then(({ data }) => {
        if (data) {
          this.dataList = data.list
          this.totalPage = data.total
          this.getAllSummaries(data.totalRow)
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
      this.selectFeeData = val
      if (val.length == 0 || val.length > 1) {
        this.addOrUpdateHandleAudit = null
      } else {
        this.addOrUpdateHandleAudit = val[0]
      }
    },
    // 新增 / 修改
    addOrUpdateHandle (todo, id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.repairRequest.init(todo, id)
      })
    },
    deleteInfo (id) {
      this.$confirm('删除后无法恢复, 确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/driverRepair/delete/` + id),
          method: 'delete'
        }).then(({ data }) => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error('操作失败')
          }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
<style lang="less" scoped>
:deep(.my-table-cell) {
  background-color: antiquewhite!important;
}
:deep(.my-table-cell-v2) {
  background-color: beige!important;
}
:deep(.my-table-cell-v3) {
  background-color: aliceblue!important;
}
</style>
